import * as Yup from "yup"

const SubmissionConverterInputValidationShema = Yup.object().shape({
  company: Yup.object().typeError("Company is required."),
  materialGroup: Yup.object().typeError("Polymer is required."),
  date: Yup.string()
    .typeError("Need month Received.")
    .required("Month is required."),
  isMaterialFromOutsideEurope: Yup.boolean(),

  canMaterialDemonstrateForAudit: Yup.boolean(),
  country: Yup.object().when("canMaterialDemonstrateForAudit", {
    is: (val: boolean) => !val,
    then: Yup.object().typeError("Recycled plastic from is required.").required("Recycled plastic from is required."),
    otherwise: Yup.object().nullable(),
  }),
  totalDemonstratedDuringAudit: Yup.number().when(
    "canMaterialDemonstrateForAudit",
    {
      is: true,
      then: Yup.number()
        .required("Field is required")
        .positive("Field must be greater than 0!"),
    },
  ),
})

export const SubmissionConverterArrayInputValidationShema = Yup.object().shape({
  submissions: Yup.array().of(SubmissionConverterInputValidationShema)})

export default SubmissionConverterInputValidationShema
